export function sendFBQEvent(elThis, eventName, params) {
  try {
    const misCookies = document.cookie.split(';')
    let facebookCookie = ''
    for (var index = 0; index < misCookies.length; index++) {
      let busca2 = misCookies[index].search('_fbc')
      if (busca2 > -1) {
        facebookCookie = misCookies[index].split('=')[1]
      }
    }
    params.fbc = facebookCookie
    if (params.event_id) {
      window.fbq(
        'track',
        eventName,
        { ...params },
        {
          eventID: params.event_id,
        },
      )
      return
    }
    window.fbq('track', eventName, params)
  } catch (error) {
    console.log('error: ', error)
  }
}
